export enum CheckoutInputLimitEnum {
  //Step 1
  EMAIL_S1 = 50,
  FIRST_NAME_S1 = 30,
  SURNAME_S1 = FIRST_NAME_S1,
  STREET_S1 = 50,
  HOUSE_NR_S1 = 9,
  ZIP_CODE_S1 = HOUSE_NR_S1,
  CITY_S1 = STREET_S1,
  PHONE_NUMBER_S1 = 20,
  REFERENCE = 100,
  //Step 3
  STREET_S3 = STREET_S1,
  HOUSE_NR_S3 = HOUSE_NR_S1,
  ZIP_CODE_S3 = HOUSE_NR_S1,
  CITY_S3 = EMAIL_S1,
  INSTRUCTION_S3 = 254,
  CONTACT_S3 = FIRST_NAME_S1,
  PHONE_NUMBER_S3 = FIRST_NAME_S1,
  //Step 4
  REMARKS_S4 = INSTRUCTION_S3,
}
